import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import styles from "../user/Login.module.css";

import { useDispatch } from "react-redux";
import { superAdminLogin } from "../../redux/actions/user/superAdminLoginAction";

import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const { Title } = Typography;

const SuperAdminLogin = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const onFinish = async (values) => {
    setLoader(true);
    const resp = await dispatch(superAdminLogin(values));
    if (resp?.success === "success") {
      setLoader(false);
      if (resp.isRequired) {
        // Redirect to change password page
        window.location.href = "/auth/change-password";
      } else {
        // Redirect to super admin dashboard
        window.location.href = "/super-admin/dashboard";
      }
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Error at login Please try again");
  };

  return (
    <>
      <Row className="card-row">
        <Col span={24}>
          <Card bordered={false} className={styles.card}>
            <Title level={3} className="m-3 text-center">
              Super Admin Login
            </Title>
            <Form
              name="basic"
              labelCol={{
                span: 6,
              }}
              wrapperCol={{
                span: 16,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                className="mb-1"
                label="Username"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please input your username!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                className="mb-2"
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item className={styles.submitBtnContainer}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loader}
                  onClick={() => setLoader(true)}
                >
                  Submit
                </Button>
              </Form.Item>

              <Form.Item className="text-center">
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <Link to="/auth/login">Regular User Login</Link>
                </div>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SuperAdminLogin;
